module.exports = __webpack_public_path__ + "img/callgreen.aa25b941.png";